import { useState } from 'react';
import axios from 'axios';
import classNames from 'classnames/bind';

import styles from './index.module.scss';
import PageTitle from '../../../components/shared/PageTitle';
import EnterAuth from './EnterAuth';
import QnaList from './QnaList';
import QnaView from './QnaView';

const cx = classNames.bind(styles);

const MyQna = () => {
  const [qnaList, setQnaList] = useState();
  const [qnaKey, setQnaKey] = useState();

  const onSetAuth = (auth) => {
    axios
      .get(`https://pulmuone.console.flyground.co.kr/api/qna/query?email=${auth.email}&password=${auth.password}`)
      .then((res) => {
        if (res.data.success) {
          const { data } = res.data;

          // 각 유형 아이템 병합
          const nextQnaList = data.reduce(
            (acc, current) => [
              ...acc,
              ...current.items.map((item) => ({
                type: current.type,
                ...item,
              })),
            ],
            [],
          );

          if (nextQnaList.length === 0) {
            alert('문의사항이 존재하지 않습니다.');
            return;
          }

          // 작성일자 기준 역정렬
          nextQnaList.sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
          setQnaList(nextQnaList);
        }
      })
      .catch((err) => console.error(err));
  };

  const onSelect = ({ type, id }) => {
    setQnaKey({ type, id });

    window.scrollTo({ top: 0 });
  };

  return (
    <div className={cx('container')}>
      <PageTitle title="내 문의사항" subtitle={!qnaList && '문의사항 작성 시 입력한 이메일을 입력해 주세요.'} reverse={true} />
      <div className={cx('limiter')}>
        {qnaList === undefined && <EnterAuth onSetAuth={onSetAuth} />}
        {qnaKey && <QnaView data={qnaKey} />}
        {qnaList && <QnaList data={qnaList} onSelect={onSelect} />}
      </div>
    </div>
  );
};

export default MyQna;
